export default __webpack_public_path__ + "favicons/fav-dev-16.png";